jQuery(function($) {
	if (!$('.image_bar').length)
		return;

	var isRoom = $('body').hasClass('single-room');
	
	// Get the image bar size setting from the data attribute
	var imageBarSize = $('.image_bar').attr('data-image-bar-size') || 'five_items';
	var slidesToShow = 5; // default
	
	// Parse the size setting
	if (imageBarSize === 'four_items') {
		slidesToShow = 4;
	} else if (imageBarSize === 'three_items') {
		slidesToShow = 3;
	} else {
		slidesToShow = 5; // default for '5_items' or any other value
	}

	$('.image_bar .slide').each(function(){
		var slide = $(this);
		var slide_index = $('.image_bar .slide').index(slide);
		slide.attr('data-slide-index', slide_index);
	});
	$('.image_bar .caption').each(function(){
		var caption = $(this);
		var caption_index = $('.image_bar .caption').index(caption);
		caption.attr('data-caption-index', caption_index);
	});

	$('.image_bar .slider').on('init', function(slick){
		setTimeout(function(){
			$('.image_bar #slider_categories .category:nth-child(2)').click();
		}, 1000);
		$('.image_bar .slick-arrow').on('click', function() {
			setTimeout(function(){
				currentSlideEl = $('.image_bar .slider .slick-current');
				currentSlideEl.focus();
			}, 300);
		});
	});

	$('#filter_mobile_button').click(function(){
		$('#slider_categories nav').toggleClass('open');
	});

	if(isRoom){
		$('#slider_categories nav').toggleClass('open');
		$('#filter_mobile_button').hide();
	}

	initializeSlick('.image_bar .slider', {
		accessibility: true,
		dots: false,
		infinite: false,
		slidesToShow: slidesToShow,
		slidesToScroll: slidesToShow,
		arrows: true,
		nextArrow: '<button class="slider_arrow next_arrow">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow">Previous</button>',
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 641,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
		]
	});

	// $('.image_bar .slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
	// 	var slider = $(this);
	// 	var slides = slider.find('.slick-slide');
	// 	var slide = slides.eq(currentSlide);
	// 	slide.focus();
	// });

	$('.image_bar #slider_categories .category').on('click', function(){
		var clicked_category = $(this);
		$('.active_category').removeClass('active_category');
		clicked_category.addClass('active_category');
		var filter_category = clicked_category.attr('data-slide-category');
		$('.image_bar .slider').slick('slickUnfilter');
		$('.image_bar .slider').slick('slickFilter', '.'+ filter_category);
		$('.image_bar .slider').slick('slickGoTo', 0);
		$('.active_caption').removeClass('active_caption');
	});

	if($(window).width() <= 480) {
		$('.image_bar .slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
			var slider = $(this);
			var slides = slider.find('.slick-slide');
			var slide = slides.eq(currentSlide);
			var slide_index = slide.attr('data-slide-index');
			$('.active_caption').removeClass('active_caption');
			$('.image_bar .caption[data-caption-index="'+slide_index+'"]').addClass('active_caption');
		});
	} else {
		$('.image_bar .slick-slide').on('mouseover focusin', function(){
			var hovered = $(this);
			var slide_index = hovered.attr('data-slide-index');
			hovered.toggleClass('active_slide');
			$('.active_caption').removeClass('active_caption');
			$('.caption h3').attr("tabindex", "-1");
			$('.image_bar .caption[data-caption-index="'+slide_index+'"]').addClass('active_caption');
			// $('.image_bar .caption[data-caption-index="'+slide_index+'"]').find('h3').attr("tabindex", "0").focus();
		});
	}
});